export default __webpack_public_path__ + "static/4-6cfec2d75facf92120f57e62cffa7055.jpeg";